// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xb8l","left":"styles_left__1nZAH"};